const palette = {
  limeGreen: '#B0F467', // informacyjny / kampanie aktywne
  amber: '#F3CE6B', // ostrzegawczy — uwaga, akcja niewymagana
  tangerine: '#DD6B20', // alarmujący — wymagana akcja użytkownika
  teal: '#95DFE3', // kampanie w planowaniu
  blue: '#3182CE', // kampanie rozliczone
  darkGreen: '#38A169',
  gray: {
    main: '#989899',
    light: '#C4C4C4',
  },
  statusActiveBg: '#e4fdd6',
  statusActiveText: '#75a761',
  statusInactiveBg: '#fedbdb',
  statusInactiveText: '#d56868',
};
export default {
  palette,
  //  notification.info    zielony   informacja, nic do zrobienia
  //  notification.warning żółty     uwaga, akcja niewymagana
  //  notification.alarm   pomarańczowy  wymaga akcji użytkownika
  notification: {
    info: { bg: palette.limeGreen, text: 'white' },
    warning: { bg: palette.amber, text: 'white' },
    alarm: { bg: palette.tangerine, text: 'white' },
  },

  campaignStatusGroups: {
    planning: palette.teal,
    ongoing: palette.limeGreen,
    in_settlement: palette.tangerine,
    settled: palette.blue,
  },

  progressBar: {
    track: palette.gray.main,
    label: palette.gray.main,
    stateCompleted: palette.darkGreen,
    stateActive: palette.tangerine,
    statePending: palette.gray.main,
    stateDisabled: palette.gray.light,
  },

  status: {
    active: {
      bg: palette.statusActiveBg,
      text: palette.statusActiveText,
    },
    inactive: {
      bg: palette.statusInactiveBg,
      text: palette.statusInactiveText,
    },
  },
};
